import { fromJS } from 'immutable';
import {
  VALUE_CHANGED,
  LOAD,
  NEXT,
  RESET,
  RESET_TRAVEL_INTERRUPTION_STATE,
  GET_FLIGHT_STATUS_REQUEST,
  GET_FLIGHT_STATUS_SUCCESS,
  GET_FLIGHT_STATUS_ERROR,
  RESET_FORM_FIELDS,
} from './constants';

const defaultFlightStatus = {
  success: null,
  flights: [],
  error: null,
  onPendingFlighAPIRequest: false,
  onSuccessFlighAPIRequest: false,
  callFailFlighAPIRequest: false,
  manuallyEnterFlight: false,
  selectedFlightIndex: null,
};

const defaultCruiseDetails = {
  cruiseLine: null,
  cruiseNumber: null,
  departureDate: null,
  arrivalDate: null,
  departurePort: null,
  arrivalPort: null,
};

const defaultOtherDetails = {
  pleaseDescribeDetailsOfYourJourneyAndWhatWasCancelled: null,
  transportService: null,
  departureLocation: null,
  destination: null,
  descriptionOfTravelType: null,
  descriptionOfEvent: null,
};

const initialTravelInterruptionState = {
  travelInterruption: 'false',
  reasonsForTripInterruption: [],
  addressTravelInterruption: '',
  dateTripInterrupted: '',
  nameOfPersonHavingSickness: '',
  dateOfBirth: '',
  relationshipToClaimant: '',
  dateSicknessOrInjuryBegan: '',
  dateEnded: '',
  natureOfSicknessOrInjury: '',
  periodOfHospitalization: '',
  lossInformationItems: [],
  fromDate: '',
  toDate: '',
};

const initialState = fromJS({
  form: {
    // Trip Cancellation
    tripCancellation: 'false',
    reasonForTripCancellation: [],
    areYouCancellingTheTripDueToMedicalReasons: 'false',
    dateTravelCancellation: '',
    reasonForTravelCancellation: '',
    nameOfPersonHavingSicknessTravelCancellation: '',
    dateOfBirthTravelCancellation: '',
    relationshipToClaimantTravelCancellation: '',
    dateSicknessOrInjuryBeganTravelCancellation: '',
    dateEndedTravelCancellation: '',
    natureOfSicknessOrInjuryTravelCancellation: '',
    lossInformationItemsTravelCancellation: [],
    fromDateTravelCancellation: '',
    toDateTravelCancellation: '',
    insuredsTravelCancellation: [],
    enableTimeTravelCancellation: null,
    typeOfTransportTravelCancellation: '',
    flightNumber: '',
    flightDate: '',
    flightDetailsTravelCancellation: defaultFlightStatus,
    cruiseLineDetailsTravelCancellation: defaultCruiseDetails,
    otherDetailsTravelCancellation: defaultOtherDetails,

    // Trip Cancellation for Any Reason
    tripCancellationForAnyReason: 'false',
    areYouCancellingTheTripDueToMedicalReasonsForAnyReason: 'false',
    dateTripCancellationForAnyReason: '',
    reasonForTripCancellationForAnyReason: '',
    lossInformationItemsTripCancellationForAnyReason: [],
    toDateTripCancellationForAnyReason: '',
    insuredsTripCancellationForAnyReason: [],
    travelSuppliersTripCancellationForAnyReason: [],

    // Travel Interruption
    ...initialTravelInterruptionState,
    enableTimeInterruption: null,
    reasonForInterruption: '',
    insuredsForInterruption: [],
    travelSuppliersTravelInterruption: [],
    typeOfTransportTravelInterruption: '',
    flightNumberTravelInterruption: '',
    flightDateTravelInterruption: '',
    flightDetailsTravelInterruption: defaultFlightStatus,
    cruiseLineDetailsTravelInterruption: defaultCruiseDetails,
    otherDetailsTravelInterruption: defaultOtherDetails,

    // Travel Delay
    travelDelay: 'false',
    reasonsForDelay: [],
    delayInformationItems: [],
    typeOfTransportTravelDelay: '',
    flightNumberTravelDelay: '',
    flightDateTravelDelay: '',
    flightDetailsTravelDelay: defaultFlightStatus,
    cruiseLineDetailsTravelDelay: defaultCruiseDetails,
    otherDetailsTravelDelay: defaultOtherDetails,

    // Missed Connection
    missedConnection: 'false',
    reasonsForMissedConnection: [],
    missedConnectionInformationItems: [],
    typeOfTransportMissedConnection: '',
    flightNumberMissedConnection: '',
    flightDateMissedConnection: '',
    flightDetailsMissedConnection: defaultFlightStatus,
    cruiseLineDetailsMissedConnection: defaultCruiseDetails,
    otherDetailsMissedConnection: defaultOtherDetails,

    // Trip Cancellation version 14 and above
    whoSickOrInjuredCusingTheCancellation: '',
    whoHadDiedCausingTheCancellation: '',
    nameOfEmployer: '',
    whenWereYouNotified: '',
    dateOfTerminationOrLayoff: '',
    howLongWereYouEmployed: '',
    wasThisWorkTransfer: '',
    nameOfServiceCallingToActiveDuty: '',
    dateYouBecame: '',
    nameOfCourtOrAuthority: '',
    dateToAppearInCourt: '',
    nameOfAuthorityHandlingTheIncident: '',
    dateOfIncident: '',
    chooseAnInsured: '',
    fullName: '',
    relationshipToTraveler: '',
    pleaseExplainWhyThisInjuryOrSicknessCausedTheTripToBeCancelled: '',
    nameOfDepartmentOfTransportationOrLocalGovernmentSubstantiatingClosure: '',
    dateOfTransportClosureIncident: '',
    dateOfTrafficAccident: '',
    nameOfTravelSupplier: '',
    whenDidOperationsResume: '',
    whatCausedTheServiceCessation: '',
    whenWasThePrimaryResidenceOrDestinationDeemedUninhabitable: '',
    whereWasUninhabitable: '',
    provideDetailsOfTheIncident: '',
    // Trip Interruption version 14 and above
    whoSickOrInjuredCusingTheCancellationTI: '',
    whoHadDiedCausingTheCancellationTI: '',
    nameOfEmployerTI: '',
    whenWereYouNotifiedTI: '',
    dateOfTerminationOrLayoffTI: '',
    howLongWereYouEmployedTI: '',
    wasThisWorkTransferTI: '',
    nameOfServiceCallingToActiveDutyTI: '',
    dateYouBecameTI: '',
    nameOfCourtOrAuthorityTI: '',
    dateToAppearInCourtTI: '',
    nameOfAuthorityHandlingTheIncidentTI: '',
    dateOfIncidentTI: '',
    chooseAnInsuredTI: '',
    fullNameTI: '',
    relationshipToTravelerTI: '',
    pleaseExplainWhyThisInjuryOrSicknessCausedTheTripToBeCancelledTI: '',
    nameOfDepartmentOfTransportationOrLocalGovernmentSubstantiatingClosureTI: '',
    dateOfTransportClosureIncidentTI: '',
    dateOfTrafficAccidentTI: '',
    nameOfTravelSupplierTI: '',
    whenDidOperationsResumeTI: '',
    whatCausedTheServiceCessationTI: '',
    whenWasThePrimaryResidenceOrDestinationDeemedUninhabitableTI: '',
    whereWasUninhabitableTI: '',
    provideDetailsOfTheIncidentTI: '',
  },
  errors: [],
});

function handleFormReset(state, fields) {
  // Only reset the specified fields to empty arrays or default values
  let newState = state;
  fields.forEach(field => {
    // Get the default value from initialState for this field
    const defaultValue = initialState.getIn(['form', field]);
    // Reset the field to its default value (empty array [] or empty string '')
    newState = newState.setIn(['form', field], defaultValue);
  });

  return newState;
}

function changesToYourJourneyStepReducer(state = initialState, action) {
  const properties = action.propertyName ? action.propertyName.split('.') : '';
  switch (action.type) {
    case VALUE_CHANGED:
      return state.setIn(properties, action.value);

    case LOAD:
      return action.payload
        ? fromJS({ form: action.payload, errors: [] })
        : initialState;

    case NEXT:
      return state.set('errors', fromJS(action.errors));

    case RESET:
      return initialState;

    case RESET_TRAVEL_INTERRUPTION_STATE:
      return state
        .setIn(['form', 'lossInformationItems'], fromJS([]))
        .mergeDeep(fromJS({ form: initialTravelInterruptionState }));

    case GET_FLIGHT_STATUS_REQUEST:
      return state.setIn(['form', action.flightObjectName], fromJS({
        ...defaultFlightStatus,
        onPendingFlighAPIRequest: true,
      }));

    case GET_FLIGHT_STATUS_SUCCESS: {
      return state.setIn(['form', action.flightObjectName], fromJS({
        flights: action.payload, // Store all flights
        success: true,
        error: null,
        onPendingFlighAPIRequest: false,
        onSuccessFlighAPIRequest: true,
        callFailFlighAPIRequest: false,
        manuallyEnterFlight: false,
        selectedFlightIndex: null,
      }));
    }

    case GET_FLIGHT_STATUS_ERROR:
      return state.setIn(['form', action.flightObjectName], fromJS({
        ...defaultFlightStatus,
        flights: action.flights || [],
        success: false,
        error: action.error,
        callFailFlighAPIRequest: true,
      }));

    case RESET_FORM_FIELDS:
      return handleFormReset(state, action.payload);

    default:
      return state;
  }
}

export default changesToYourJourneyStepReducer;



// WEBPACK FOOTER //
// ./app/containers/FastCover/Trawick.ChangesToYourJourney/reducer.js